import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
  HttpContextToken,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { AuthService } from '../app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { PermissionDeniedService } from './core/services/permission-denied.service';
import { PermissionDeniedModalService } from './core/services/permission-denied-modal.service';
import { PermissionDeniedMessage } from './core/models/api/errors/permission-denied-error.interface';

/** Set on a request to stop a 403 from opening the global permission-denied popup. */
export const SKIP_PERMISSION_DENIED_POPUP = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorCodesInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private notificationService: NotificationsService,
    private _auth: AuthService,
    private permissionDeniedService: PermissionDeniedService,
    private permissionDeniedModalService: PermissionDeniedModalService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Public tools own their authentication-style errors (for example, a VIN
    // mismatch is returned as 401) and must never trigger the app sign-out flow.
    if (request.url.includes('/public/')) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap(
        (res) => {
            
        },
        (err) => {       
          if (err instanceof HttpErrorResponse) {
            
            //user didn't subscribe before so he has the ability to subscribe
            if(err?.error?.identifierCode == "127001"){
              this.router.navigate([`${environment.fiGalaxyUrl}/auth/sign-up-services`]);
            }
            if(err?.error?.identifierCode == "101005"){
              this.router.navigate([`/auth/sign-up/verify-email-step-two`]);
            }
            // A failed logout must not be treated as a completed sign-out.
            // The caller clears the session only after a successful response.
            if (err.status === 401 && !request.url.includes('/logout')) {
              this._auth.signOut();
            }
            
            if (request.context.get(SKIP_PERMISSION_DENIED_POPUP)) {
              // Caller handles 403 itself (e.g. hides a section silently).
            } else if (this.isPermissionDeniedError(err)) {
              this.permissionDeniedModalService.showPermissionDeniedModal(err.error);
            } else if (err.status === 403) {
              const permission = err.error?.permission || 'read_claim_status'; // Default/Fallback for demo
              this.permissionDeniedService.show(permission);
            }
         
          }
        }
      )
    );
  }

  private isPermissionDeniedError(error: HttpErrorResponse): boolean {
    const errorBody = error.error;
    return (
      (error.status === 403 || errorBody?.error === 403) &&
      errorBody?.message &&
      typeof errorBody.message === 'object' &&
      errorBody.message?.required_permission &&
      errorBody.message?.steps &&
      Array.isArray(errorBody.message.steps)
    );
  }
}
